<template>
  <Transition name="fade">
    <div
      v-show="!hidden"
      class="universal-search-mobile"
    >
      <div class="search-bar">
        <slot name="header" />
      </div>

      <div class="content">
        <slot />
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
export interface UniversalSearchMobileProps {
  hidden?: boolean;
}

defineProps<UniversalSearchMobileProps>();
</script>

<style lang="scss" scoped>
@import "shared/css/utils/transitions/fade";

// Mobile search is not a dialog — it is a surface that takes over the viewport,
// mounted in the app itself rather than in the modal container. That keeps it
// out of the container's stacking context and away from the focus trap, so
// Quasar's filter action sheets can still open above it.
.universal-search-mobile {
  position: absolute;
  inset: 0;

  // Over Quasar's layout header, which sits at 2000.
  z-index: 3000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: env(safe-area-inset-top);
  background: $body-background;
}

.search-bar {
  background: white;
}

.content {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
</style>
